"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FocusZoneTabbableElements = exports.FocusZoneDirection = exports.FocusZone = void 0;
var react_focus_1 = require("@fluentui/react-focus");
Object.defineProperty(exports, "FocusZone", { enumerable: true, get: function () { return react_focus_1.FocusZone; } });
Object.defineProperty(exports, "FocusZoneDirection", { enumerable: true, get: function () { return react_focus_1.FocusZoneDirection; } });
Object.defineProperty(exports, "FocusZoneTabbableElements", { enumerable: true, get: function () { return react_focus_1.FocusZoneTabbableElements; } });
//# sourceMappingURL=FocusZone.js.map